import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService, SessionStorageService, UserService } from '@socrates/socrates-shared';
import { AccountOnboardingState, User } from '@socrates/common';
import { environment } from '../../environments/environment';

@Injectable()
export class RouteGuard implements CanActivate {

	constructor(
		private userService: UserService,
		private sessionStorage: SessionStorageService,
		private router: Router,
		private permService: PermissionService,
	) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		await this.permService.loadPermissions(environment.envName);
		try {
			await this.userService.checkSession();
		} catch {
			this.userService.detouredRoute = state.url;
			this.router.navigateByUrl('/login');
			return false;
		}
		const user: User = this.userService.getUser() || this.userService.getUserFromSession();
		// Gate: pillar review must be completed before accessing anything else
		if (user.accountState === AccountOnboardingState.PillarReviewRequired) {
			const targetUrl = state.url;
			if (!targetUrl.startsWith('/pillars') && !targetUrl.startsWith('/logout')) {
				this.router.navigateByUrl('/pillars');
				return false;
			}
		}

		const requiredPrivilege: string = route.data?.['privilege'];
		if (requiredPrivilege && !this.permService.permitted(user, requiredPrivilege)) {
			this.router.navigateByUrl('/dashboard');
			return false;
		}
		return true;
	}
}
